module.exports = __webpack_public_path__ + "img/119.3.798a1dae.png";